export default __webpack_public_path__ + "static/media/story2.13f2be77.jpg";